import { Autocomplete as NextAutocomplete, type AutocompleteProps } from "@heroui/react";
import { withFormComponent } from "./hoc";

// 设置 displayName 以便组件识别
(NextAutocomplete as React.ComponentType<AutocompleteProps>).displayName = "HeroUI.Autocomplete";

export const Autocomplete = withFormComponent(NextAutocomplete); 